<ng-container *ngIf="email">
    <tt-input ttLabel="from_cust_no" [ttModel]="email.from_cust_no" ttReadonly [ttButtons]="email.from_cust_no > '0' ? fromCustomerFormButtons : fromCustomerEmptyFormButtons"></tt-input>
    <tt-search
        ttLabel="from_cust_name"
        [(ttModel)]="email.from_cust_name"
        [ttSearch]="searchFromCustomer"
        (ttOnSelected)="onFromCustomerSelected($event)"
        (ttOnClear)="onFromCustomerSelected()"
    ></tt-search>

    <!-- <tt-input ttLabel="pers_no" [ttModel]="email.pers_no" ttReadonly></tt-input> -->

    <tt-select ttLabel="from_pers_name" [(ttModel)]="email.pers_no" [ttData]="fromPersons" ttShowClearButton></tt-select>

    <ng-container *ngIf="email.pers_no == '0'">
        <tt-input ttLabel="sender_name_new" [(ttModel)]="email.sender_name_new"></tt-input>
    </ng-container>
    <tt-input ttLabel="sender_email_new" [(ttModel)]="email.sender_email_new"></tt-input>

    <tt-button-save ttText="email_fromperson_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    <!-- {{ email | json }}
    {{ fromPersons | json }} -->
</ng-container>
